import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const ORDER_DETAILS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    NEIGHBOURS_DIRECTION: '/neighbours-direction/',
    LICENCE_TYPES: '/licence-types/',
    ADMIN_ORDER_BUILDING_LOCATION_UPDATE: (id: number) => `/admin-order-building-location-update/${id}/`,
    ADMIN_ORDER_PROPERTY_UNIT: (id: number) => `/admin-order-property-unit/${id}/`,
    ADMIN_BUILDING_SPECIFICATIONS: (orderId: number) => `/admin-building-specifications/${orderId}/`,
    ADMIN_ORDER_BUILDING_INFO_UPDATE: (orderId: number) => `/admin-order-building-info-update/${orderId}/`,
    ADMIN_BUILDING_OTHER_FEATURES: (orderId: number) => `/admin-building-other-features/${orderId}/`,
    ADMIN_INFRASTRUCTURE_AND_SERVICES: (id: number) => `/admin-infrastructure-and-services/${id}/`,
  }),
} as const;
